import { Station } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode } from 'react';

export function StationContainer({
  children,
  showGradient = false,
  station,
}: {
  children: ReactNode;
  showGradient?: boolean;
  station?: Station;
}) {
  const defaultProgressIndicator = (
    <div className="flex flex-col items-center h-full">
      <div className="bg-neutrals-500 rounded-full size-5 shrink-0" />
      <div
        className={`h-full w-0.5 ${showGradient ? 'bg-linear-to-b from-neutrals-500 to-transparent' : 'bg-neutrals-500'}`}
      />
    </div>
  );

  const istAbgeschlossenProgressIndicator = (
    <div className="flex flex-col items-center h-full">
      <div className="bg-primary-green-100 rounded-full size-5 shrink-0 flex items-center justify-center">
        <FontAwesomeIcon
          icon={faCheck}
          className="text-primary-green-500 size-2"
        />
      </div>
      <div className={`h-full w-0.5 bg-primary-green-500`} />
    </div>
  );

  const istAktivProgressIndicator = (
    <div className="flex flex-col items-center h-full">
      <div className="bg-primary-blue-500 rounded-full size-5 shrink-0" />
      <div className={`h-full w-0.5 bg-primary-blue-500`} />
    </div>
  );

  return (
    <div className="grid grid-cols-[20px_1fr] gap-3">
      {!station
        ? defaultProgressIndicator
        : station.istAbgeschlossen
          ? istAbgeschlossenProgressIndicator
          : station.istAktiv
            ? istAktivProgressIndicator
            : defaultProgressIndicator}
      {children}
    </div>
  );
}
